export enum PlanStatusActive {
  ACTIVE = "active",
  CANCELLED = "cancelled",
}

export enum PlanName {
  FREE_TRIAL = "Free Trial",
  PLAN_MONTHLY = "All-In-One PlanMonthly",
}

export enum ValidationSuscriptionButton {
  PLAN_FREE_TRIAL = "PLAN_FREE_TRIAL",
  RECORDING_USAGES = "RECORDING_USAGES",
}

export enum StatusFile {
  ERROR = "Error",
  READY = "Ready",
}

export enum DefaultRecordingTemplates {
  SOAP = "SOAP Template",
  SPECIALIST = "Specialist Template",
  VOICE_TO_TEXT = "Voice to Text Dictation",
}
